import { hasPermission, type Permission } from '@shared/permissions';
import { useProjectRole } from '@/lib/current-project';
import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the caller's role on the current project (the `/p/:slug` the tab is in) allows
 * `permission`. Always false outside a project. Admins are maintainers on every project, so the
 * role from GET /api/project already says so.
 */
export function usePermission(requiredPermission: Permission): boolean {
  const role = useProjectRole();
  return hasPermission(role, requiredPermission);
}

/**
 * Whether the signed-in user is an admin: the one place the app reads it (the session answer, kept
 * in the auth store). Admins see Fleet and People and act as maintainer on every project.
 */
export function useIsAdmin(): boolean {
  return useAuthStore((s) => Boolean(s.user?.is_admin));
}
